import React, {useState, useContext} from "react"
import {useMutation} from "@apollo/client"
import {useHistory} from "react-router-dom"

import {ImportForm} from "../Form/ImportForm"

import importAddListMutation from "graphql/Transcode/Import/mutation/importAddList"
import importListQuery from "graphql/Transcode/Import/query/importList"

import './style.scss'
import {alertContext} from "context/Alert/alert"
import {URL_BACKOFFICE_TRANSCODE_IMPORT_LIST} from "static/constant/url"
import {BackofficePage, BackofficePanel, BackofficeEmptyState} from "components/backoffice/Layout/BackofficePage"

export const ImportAddList = (props: any) => {

  const history = useHistory()

  const {setError, setMessage} = useContext(alertContext)
  const [canSubmit, updateCanSubmit] = useState(false)

  const [importList, updateImportList] = useState<any[]>([{
    id: new Date().getTime(),
  }])

  const [mutate] = useMutation(importAddListMutation)

  const onChange = (updateEl: any) => {
    updateCanSubmit(true)
    updateImportList(importList.map((el) => (el.id === updateEl?.id) ? updateEl: el))
  }

  const deleteItem = (id: number) => {
    updateImportList(importList.filter((el) => (el?.id !== id)))
  }

  const handleAdd = () => {
    const lastImport: any = importList[importList.length - 1]
    updateImportList([...importList, {
      id: new Date().getTime(),
      Provider: lastImport?.Provider,
      type: "show",
      Show: lastImport?.Show,
      Season: lastImport?.Season,
    }])
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    updateCanSubmit(false)
    mutate({
      refetchQueries: [
        {
          query: importListQuery,
        }
      ],
      variables: {
        input: importList.map((el: any) => {
          const {id, Season, Show, type, ...rest} = el
          return rest;
        })
      }
    })
    .then(() => setMessage("Imports ajoutés à la file", () => {
      history.push(URL_BACKOFFICE_TRANSCODE_IMPORT_LIST)
    }))
    .catch(() =>{
      setError("Impossible d'ajouter ces imports")
      updateCanSubmit(true)
    })
  }

  // const isSubmitable = importList?.length > 0

  return <BackofficePage
    className="import-add-list-container"
    eyebrow="Centre de traitement"
    title="Préparer des imports"
    description="Associez chaque fichier à son média puis envoyez le lot dans la file de traitement."
    icon="fa-file-import"
    actions={<button type="button" className="bo-secondary-action" onClick={() => handleAdd()}><span className="fas fa-plus"></span>Ajouter une ligne</button>}
  >
    <form onSubmit={(e: any) => handleSubmit(e)}>
      <BackofficePanel
        title="Fichiers à importer"
        description={`${importList.length} élément${importList.length > 1 ? "s" : ""} dans ce lot`}
        icon="fa-list"
      >
        <div className="import-form-stack">
        {importList && importList.map((element: any, index: number) => {
          return <article key={`import_${element.id}_${index}`} className="import-form-card">
            <header className="import-form-card-header">
              <span className="import-form-index">{String(index + 1).padStart(2, "0")}</span>
              <div><strong>Nouvel import</strong><small>Sélectionnez un média et son fichier source</small></div>
              <button type="button" className="remove-import-line" onClick={() => deleteItem(element?.id)} aria-label={`Supprimer l'import ${index + 1}`}><span className="icon-trash"></span></button>
            </header>
            <div className="import-form-card-body">
                <ImportForm onChange={(el) => onChange(el)} value={element} />
            </div>
          </article>
        })}
        </div>
        {!importList.length && <BackofficeEmptyState title="Lot vide" description="Ajoutez une ligne pour préparer un import." icon="fa-file-video" action={<button type="button" className="bo-secondary-action" onClick={() => handleAdd()}>Ajouter une ligne</button>} />}
      </BackofficePanel>
      <div className="import-batch-actions">
        <span>{canSubmit ? "Le lot est prêt à être enregistré." : "Complétez au moins un import pour continuer."}</span>
        <button type="submit" disabled={!canSubmit || !importList.length} className="bo-primary-action"><span className="fas fa-arrow-right"></span>Envoyer dans la file</button>
      </div>
    </form>
  </BackofficePage>
}
